<template>
  <div class="top_nav">
    <div class="container-fluid">
      <div class="row end-xs">
        <need-help></need-help>
        <log-out-button></log-out-button>
        <language-switcher></language-switcher>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher'
import LogOutButton from './LogOut'
import NeedHelp from './NeedHelp'
export default {
  data() {
    return {}
  },
  components: {
    LanguageSwitcher,
    LogOutButton,
    NeedHelp
  }
}
</script>
